enum GatheringRateModifierId {
    WHEELBARROW = 'WHEELBARROW',
    SURVIVALTECH = 'SURVIVALTECH',
    DOUBLE_BROADAX = 'DOUBLE_BROADAX',
    LUMBER_PRESERVATION = 'LUMBER_PRESERVATION',
    CROSSCUT_SAW = 'CROSSCUT_SAW',
    HORTICULTURE = 'HORTICULTURE',
    FERTILIZATION = 'FERTILIZATION',
    CROSS_BREEDING = 'CROSS_BREEDING',
    SPECIALIZED_PICK = 'SPECIALIZED_PICK',
    ACID_DISTILLATION = 'ACID_DISTILLATION',
    IMPROVED_DOUBLE_BROADAX = 'IMPROVED_DOUBLE_BROADAX',
    IMPROVED_HORTICULTURE = 'IMPROVED_HORTICULTURE',
    IMPROVED_SPECIALIZED_PICK = 'IMPROVED_SPECIALIZED_PICK',
    FORESTRY = 'FORESTRY',
    ENGLISH_DARK_AGE = 'ENGLISH_DARK_AGE',
    ENGLISH_FEUDAL_AGE = 'ENGLISH_FEUDAL_AGE',
    ENGLISH_CASTLE_AGE = 'ENGLISH_CASTLE_AGE',
    ENGLISH_IMPERIAL_AGE = 'ENGLISH_IMPERIAL_AGE',
    GRANARY = 'GRANARY',
    BOUNTY_100 = 'BOUNTY_100',
    BOUNTY_250 = 'BOUNTY_250',
    BOUNTY_500 = 'BOUNTY_500',
    MUSLIM_BERRIES = 'MUSLIM_BERRIES',
    GOLDEN_AGE_1 = 'GOLDEN_AGE_1',
    GOLDEN_AGE_2 = 'GOLDEN_AGE_2',
    AGRICULTURE = 'AGRICULTURE',
    ANATOLIAN_HILLS = 'ANATOLIAN_HILLS',
    DRAGON_VILLAGER = 'DRAGON_VILLAGER',
    AYYUBIDS_GOLDEN_AGE_1 = 'AYYUBIDS_GOLDEN_AGE_1',
    DAIMYO_MANOR = 'DAIMYO_MANOR',
    DAIMYO_PALACE = 'DAIMYO_PALACE',
    SHOGUNATE_CASTLE = 'SHOGUNATE_CASTLE',
    CISTERN_LEVEL_1 = 'CISTERN_LEVEL_1',
    CISTERN_LEVEL_2 = 'CISTERN_LEVEL_2',
    CISTERN_LEVEL_3 = 'CISTERN_LEVEL_3',
    CISTERN_LEVEL_4 = 'CISTERN_LEVEL_4',
    CISTERN_LEVEL_5 = 'CISTERN_LEVEL_5',
    HOUSE_OF_LANCASTER_SHEEP = 'HOUSE_OF_LANCASTER_SHEEP',
    KNIGHTS_TEMPLAR_DARK_AGE = 'KNIGHTS_TEMPLAR_DARK_AGE',
    KNIGHTS_TEMPLAR_FEUDAL_AGE = 'KNIGHTS_TEMPLAR_FEUDAL_AGE',
    KNIGHTS_TEMPLAR_CASTLE_AGE = 'KNIGHTS_TEMPLAR_CASTLE_AGE',
    KNIGHTS_TEMPLAR_IMPERIAL_AGE = 'KNIGHTS_TEMPLAR_IMPERIAL_AGE',
    TUGHLAQ_ECO_1 = 'TUGHLAQ_ECO_1',
    TUGHLAQ_ECO_2 = 'TUGHLAQ_ECO_2',
    TUGHLAQ_ECO_3 = 'TUGHLAQ_ECO_3',
    ROTATION_GRAZING = 'ROTATION_GRAZING',
    OVER_GRAZING = 'OVER_GRAZING',
    MACEDONIAN_DYNASTY_GRAND_WINERY = 'MACEDONIAN_DYNASTY_GRAND_WINERY',
}

export const DOUBLE_BROADAX_MULTIPLIER = 1.1;
export const LUMBER_PRESERVATION_MULTIPLIER = 1.09;
export const CROSSCUT_SAW_MULTIPLIER = 1.08;
export const HORTICULTURE_MULTIPLIER = 1.08;
export const FERTILIZATION_MULTIPLIER = 1.067;
export const CROSS_BREEDING_MULTIPLIER = 1.067;
export const SPECIALIZED_PICK_MULTIPLIER = 1.12;
export const ACID_DISTILLATION_MULTIPLIER = 1.11;

export default GatheringRateModifierId;
